import Vuetify from "vuetify/lib";
import Vue from "vue";
import VuetifyConfirm from "vuetify-confirm";
import "@mdi/font/css/materialdesignicons.css";
import hu from "vuetify/es5/locale/hu";

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#002554",
        secondary: "#FF671F",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#91b1cf",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {},
    },
  },
  lang: {
    locales: {
      hu,
    },
    current: "hu",
  },
  icons: {
    iconfont: "mdi",
  },
});

// https://www.npmjs.com/package/vuetify-confirm
Vue.use(VuetifyConfirm, {
  vuetify,

  buttonTrueText: "Igen",
  buttonFalseText: "Mégse",
  color: "error",
  icon: "warning",
  title: "Figyelem",
  width: 350,
  property: "$confirm",
});

Vue.use(Vuetify);

export default vuetify;
